import { useIsMobileHook } from '@teliaee/telia-common-components';
import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { ISelectorItemProps, Selector } from 'telia-front-react';
import { useStores } from '../stores/RootStore';

const MobileLifeVolumeSelectors = observer((): React.JSX.Element => {
  const { translate } = useContext(TranslationsContext);
  const { isMobile } = useIsMobileHook();
  const {
    mobileLifeStore: { showOnlyCallPackages, setShowOnlyCallPackages },
  } = useStores();

  const options: ISelectorItemProps[] = [
    {
      id: 'all',
      name: 'volume',
      value: 'all',
      label: translate('mobile.package.selectors.all'),
    },
    {
      id: 'calls',
      name: 'volume',
      value: 'calls',
      label: translate('mobile.package.selectors.calls'),
    },
  ];

  return (
    <Selector
      id="mobile-life-volume-selector"
      hideLabel={true}
      label={translate('mobile.package.selectors')}
      value={showOnlyCallPackages ? 'calls' : 'all'}
      items={options}
      size={isMobile ? 'small' : undefined}
      onChange={(value) => setShowOnlyCallPackages(value === 'calls')}
    />
  );
});

export default MobileLifeVolumeSelectors;
